import { useFindRecord } from 'api/APIHooks';

export const useFeeScheduleProgramMetafields = (fspId) => {
  const { data: fspData, isLoading, isSuccess } = useFindRecord(
    'fee_schedule_program',
    fspId,
    {
      queryConfig: {
        placeholderData: undefined,
        refetchOnWindowFocus: false,
        staleTime: Infinity,
        enabled: !!fspId,
      },
    },
  );
  const metafields = fspData?.data?.data?.metafields ?? [];
  return { metafields, isLoading, isSuccess };
};
